import styled from 'styled-components/native';

export const ModalStackHeaderContainer = styled.View<{
  background: string;
}>`
  background-color: ${({ background }) => background};
  flex-direction: row;
  justify-content: center;
`;

export const ModalTitleWrapper = styled.Pressable`
  flex: 1;
  text-align: center;
  margin: auto;
`;

export const HeaderButtonWrapper = styled.View<{
  position: 'left' | 'right';
}>`
  position: absolute;
  justify-content: center;
  ${(props) => (props.position === 'left' ? 'left: 0px;' : '')}
  ${(props) => (props.position === 'right' ? 'right: 0px;' : '')}
  margin: auto;
`;
